import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';

export const custom: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.tabs.custom') as string;
			},
			trappRoute(to: Route): string {
				return `/sgp.shtml?hcgd=${to.params.groupId}`;
			},
		},
		path: 'custom',
		name: Routes.GROUP_CUSTOM,
		component: () => import(/* webpackChunkName: "group_custom" */ '@front-app/views/home/group/GroupCustom.vue'),
	},
];
